var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Voucher" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Code",
                        error: _vm.$v.form.Code,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url: "VisionNextFinance/api/CsStatus/Search",
                          "dynamic-and-condition": { StatusIds: [1] },
                          disabled: _vm.insertReadonly.StatusId
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("StatusId", $event)
                          }
                        },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "CustomerId",
                        error: _vm.$v.form.CustomerId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          searchable: true,
                          url:
                            "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                          "custom-option": true,
                          "is-customer": true,
                          "or-condition-fields":
                            "Code,Description1,CommercialTitle",
                          "dynamic-and-condition": { StatusIds: [1] },
                          disabled: _vm.insertReadonly.CustomerId
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("CustomerId", $event)
                          }
                        },
                        model: {
                          value: _vm.customer,
                          callback: function($$v) {
                            _vm.customer = $$v
                          },
                          expression: "customer"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("get.Voucher.VoucherDetails"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentNumber",
                            error: _vm.$v.form.DocumentNumber,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.DocumentNumber
                            },
                            model: {
                              value: _vm.form.DocumentNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentNumber", $$v)
                              },
                              expression: "form.DocumentNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentDate",
                            error: _vm.$v.form.DocumentDate,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.DocumentDate
                            },
                            model: {
                              value: _vm.form.DocumentDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentDate", $$v)
                              },
                              expression: "form.DocumentDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DueDate",
                            error: _vm.$v.form.DueDate,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.DueDate },
                            model: {
                              value: _vm.form.DueDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DueDate", $$v)
                              },
                              expression: "form.DueDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SerialNumber",
                            error: _vm.$v.form.SerialNumber,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.SerialNumber
                            },
                            model: {
                              value: _vm.form.SerialNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SerialNumber", $$v)
                              },
                              expression: "form.SerialNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrencyId",
                            error: _vm.$v.form.CurrencyId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextSystem/api/SysCurrency/Search",
                              disabled: _vm.insertReadonly.CurrencyId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CurrencyId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.currency,
                              callback: function($$v) {
                                _vm.currency = $$v
                              },
                              expression: "currency"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CsTotal",
                            error: _vm.$v.form.CsTotal,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.CsTotal
                            },
                            model: {
                              value: _vm.form.CsTotal,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CsTotal", $$v)
                              },
                              expression: "form.CsTotal"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RepresentativeId",
                            error: _vm.$v.form.RepresentativeId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              searchable: true,
                              url:
                                "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                              orConditionFields:
                                "Code,Description1,Name,Surname",
                              "dynamic-and-condition": { StatusIds: [1] },
                              "custom-option": true,
                              disabled: _vm.insertReadonly.RepresentativeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RepresentativeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.representative,
                              callback: function($$v) {
                                _vm.representative = $$v
                              },
                              expression: "representative"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteId",
                            error: _vm.$v.form.RouteId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextRoute/api/Route/AutoCompleteSearch",
                              "dynamic-and-condition": { StatusIds: [1] },
                              disabled: _vm.insertReadonly.RouteId,
                              "order-by-columns": [
                                { Column: "Description1", OrderByType: 0 }
                              ],
                              "page-count": 500
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType("RouteId", $event)
                              }
                            },
                            model: {
                              value: _vm.route,
                              callback: function($$v) {
                                _vm.route = $$v
                              },
                              expression: "route"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.creditcard.reminder"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.customerReminder,
                              callback: function($$v) {
                                _vm.customerReminder = $$v
                              },
                              expression: "customerReminder"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51411424", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51411424","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Voucher/update.vue
// module id = null
// module chunks = 